import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CommentsService } from 'src/app/services/comments/comments.service';

@Component({
  selector: 'app-comments',
  imports: [CommonModule],
  templateUrl: './comments.component.html',
  styleUrl: './comments.component.css'
})
export class CommentsComponent {
  comments: any[] = [];
  loading = false;

  constructor(private commentsService: CommentsService) {}

  ngOnInit() {
    this.loadComments();
  }

  loadComments() {
    this.loading = true;

    this.commentsService.getComments().subscribe((res: any) => {
      this.comments = res.data || res;
      this.loading = false;
    });
  }

  approve(id: number) {
    this.commentsService.approve(id).subscribe(() => {
      this.loadComments();
    });
  }

  reject(id: number) {
    this.commentsService.reject(id).subscribe(() => {
      this.loadComments();
    });
  }

  delete(id: number) {
    if (!confirm('ნამდვილათ გსურთ წაშლა?')) return;

    this.commentsService.delete(id).subscribe(() => {
      this.loadComments();
    });
  }
}
